import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initAnalytics } from './services/analytics'
import './index.css'

// Initialize analytics (optional - only if VITE_POSTHOG_KEY is set)
initAnalytics()

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
